module.exports = __webpack_public_path__ + "static/img/finance.c7472265.png";